import React, { useContext, useState } from "react";
import { AuthContext } from "../../AuthContext";
import Button from "@mui/material/Button";
import "./home.css";
import { useNavigate } from "react-router-dom";
import ReusableDialog from "../../common/dialog/dialog";
import { useDispatch } from "react-redux";
import { resetState } from "../../redux/actions/authActions";
// Import the reset action

const HomePage = () => {
  const { logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const dispatch = useDispatch(); // Redux dispatch function
  const [open, setOpen] = useState(false);

  const handleLogoutConfirm = () => {
    setOpen(false);

    // Dispatch Redux reset action to clear the store
    dispatch(resetState());

    // Clear local storage and session storage (if applicable)
    localStorage.clear();
    sessionStorage.clear();

    // Call the existing logout function
    logout();

    // Redirect to login page
    navigate("/login");
  };

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleCloseDialog = () => {
    setOpen(false);
  };

  return (
    <div className='container'>
      <div className='header'>Welcome to My Logout Page</div>

      <div className='button'>
        <Button variant='contained' onClick={handleOpenDialog}>
          Logout
        </Button>
      </div>

      <ReusableDialog
        isOpen={open}
        onClose={handleCloseDialog}
        title='Confirm logout?'
        contentText='Unsaved changes will be lost. Please save your work before logging out. Confirm to proceed.'
        onSubmit={handleLogoutConfirm}
        submitText='Yes, Log Out'
        cancelText='Cancel'
      />
    </div>
  );
};

export default HomePage;
